
export const UNDELIVER_ORDER= 'UNDELIVER_ORDER'
export const UNDELIVER_ORDER_SUCCESS= 'UNDELIVER_ORDER_SUCCESS'
export const UNDELIVER_ORDER_ERROR='UNDELIVER_ORDER_ERROR'


export const UnDeliverOrder= (data) => ({
    type: UNDELIVER_ORDER,
    payload: data
});